import { faCircleNotch, faPlus } from "@fortawesome/pro-regular-svg-icons";

import { Button } from "src/design-system/Button";
import { ActionButtonProps } from "src/design-system/EmptyState";
import { Icon } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";

const ADD_CHART_TOOLTIP_LOADING =
  "Please wait for the chart data to load. This might take a few minutes.";
const ADD_CHART_TOOLTIP_DISABLED =
  "Initiate a test run to enable charting features and to derive insights from your data.";

export const getAddChartActionButton = ({
  disabled,
  loading,
  onClick,
}: {
  disabled: boolean;
  loading: boolean;
  onClick: () => void;
}): ActionButtonProps => ({
  label: "Add chart",
  icon: faPlus,
  isDisabled: disabled,
  isLoading: loading,
  dataLoc: "analytics-add-chart-button",
  onClick,
  tooltip: {
    body: loading ? ADD_CHART_TOOLTIP_LOADING : ADD_CHART_TOOLTIP_DISABLED,
    placement: "top",
    disabled: !disabled && !loading,
  },
});

export const AddChartButton: React.FC<{
  size?: "sm";
  disabled: boolean;
  loading: boolean;
  onClick: () => void;
}> = ({ size, disabled: buttonDisabled, onClick, loading }) => (
  <Tooltip
    body={loading ? ADD_CHART_TOOLTIP_LOADING : ADD_CHART_TOOLTIP_DISABLED}
    disabled={!buttonDisabled && !loading}
    placement="top"
    asChild
  >
    <Button
      dataLoc={`analytics-add-chart-button${loading ? "-loading" : ""}`}
      isDisabled={!loading && buttonDisabled}
      iconLeft={!loading ? faPlus : undefined}
      size={size}
      variant="secondary"
      onClick={!loading ? onClick : undefined}
    >
      <span className="flex items-center gap-2">
        {loading && <Icon icon={faCircleNotch} size="2xs" spin />}
        {loading ? "Loading chart data..." : "Add chart"}
      </span>
    </Button>
  </Tooltip>
);
